"use strict";
import { __module as a } from "./index.es394.js";
import { __require as h } from "./index.es379.js";
import { __require as p } from "./index.es395.js";
import { __require as g } from "./index.es396.js";
var n;
function y() {
  return n ? a.exports : (n = 1, (function(i, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "getDomainLocale", {
      enumerable: !0,
      get: function() {
        return c;
      }
    });
    const l = h(), u = process.env.__NEXT_ROUTER_BASEPATH || "";
    function c(r, f, s, d) {
      if (process.env.__NEXT_I18N_SUPPORT) {
        const m = p().normalizeLocalePath, _ = g().detectDomainLocale, o = f || m(r, s).detectedLocale, t = _(d, void 0, o);
        if (t) {
          const L = "http" + (t.http ? "" : "s") + "://", P = o === t.defaultLocale ? "" : "/" + o;
          return "" + L + t.domain + (0, l.normalizePathTrailingSlash)("" + u + P + r);
        }
        return !1;
      } else
        return !1;
    }
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), i.exports = e.default);
  })(a, a.exports), a.exports);
}
export {
  y as __require
};
//# sourceMappingURL=index.es298.js.map
